<template>
  <div class="modal fade error-modal" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
    id="error-modal">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="container py-4 px-4">
          <label style="text-align: center;">{{ message }}</label>

          <div style="text-align: center">
            <button class="btn mr-1"
              style="width: 100px; color: #AC8400; background-color: white; border-color: #AC8400;"
              @click="hideModal('#error-modal')">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { type } from 'jquery';
import InputLabel from '../../../components/UI/InputLabel.vue';


export default {
  name: "error-modal",
  
  components: {
    InputLabel
  },

  props: {
    message: {
      type: String,
      required: false,
      default: 'Only TBA role is allowed to manage the default maximum advanced purchase period'
    },
  },

  data() {
    return {
      data: {
        title: '',
        start_date: '',
        end_date: '',
        type: ''
      },


    };
  },

  methods: {
    hideModal(name) {
      $(name).modal('hide');
    },

    handleSubmit() {
      this.$emit("submitPromo");
    },
  },
};
</script>
